import React, { Component } from 'react';
import $ from 'jquery';
import ReactStars from 'react-stars';
import { Link} from 'react-router';
import WebHeaderInner from '../Common/WebHeaderInner.js';
import {Breadcrumb} from 'react-bootstrap';
import { Panel} from 'react-bootstrap';
import WebFooter from '../Common/WebFooter.js';
import InfiniteScroll from 'react-infinite-scroll-component';

import { ShareButtons,  generateShareIcon } from 'react-share';
const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');


const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';
// "/subdeals/:BrandName/:CatName/:ProName/:Pid"
// "/subdeals/:Pid" 
// "/subdeals/:BrandName/:CatName/:DType/:ProName/:Pid"
export default class WebSubDeals extends Component {
    constructor(props){
    super(props);
    this.state={
      feedsList: [],
      fulldata:[],
      feedbrands: [],
      feed_sub_cat:[],
      feedcat: [],
      totdata:'',
      types:[],
      tid : this.props.params.Tid,
      type: this.props.params.Type,
      // dtype: this.props.params.DType,
      pid: this.props.params.Pid,
      data_type: this.props.params.DType,
      lod: false,
      loading: false,
      loadmore_number: 2,
      loadmore_status: 0,
      set_type:'',
      next_page:'',
      loading_gif:false,
      h1_desc:'',
      sortList:[],

      selected:'',
      count:'',
    };
    // localStorage.setItem('d_type',this.props.params.Dtype);
    this.test=this.test.bind(this);  
    this.loadMoreDeals=this.loadMoreDeals.bind(this);
    this.getDeviceId=this.getDeviceId.bind(this);
    // this.getTypes=this.getTypes.bind(this);
    // this.getPoductDeals=this.getPoductDeals.bind(this);

     this.getSelectedCatSort =this.getSelectedCatSort.bind(this); 
     this.fetchData =this.fetchData.bind(this);
     this.refresh =this.refresh.bind(this);
  }
   fetchData()
  {
      // this.state.next_page, this.state.set_type,this.props.params.Tid,this.props.params.DType
      var num=this.state.next_page;
      var sortid =this.state.sortid;
      if(localStorage.user_id)
      {
         var  uid=localStorage.getItem('user_id')
      }
      else
      {
         uid=0;
      }
      var getfunc="";
      var data1="";
      var data2="";
       data1={from:'desktop_web',uid:uid,page:num,limit:20,sort:sortid,pid:this.state.pid};
       data2=JSON.stringify(data1);
       getfunc="getNewsearch";
      
      if(this.state.loadmore_status===1)
      {
            this.setState({
              loading_gif:true,
            })
              $.ajax({
                  method:'POST',
                  dataType:'json',
                  data:{req:data2},
                  url:baseUrl+getfunc,
                  success:function(data)
                  {
                      if(data.products)
                      {
                          if(data.load_more===1)
                          {
                            this.setState({
                                feedsList:this.state.feedsList.concat(data.products),
                                offer: data,
                                todata: data,
                                loadmore_status:data.load_more,
                                set_type:data.set_type,
                                next_page:data.next_page,
                                loading_gif:false,
                                h1_desc:'Shop best deals on '+data1.product_name,
                                selected:data.product_name,
                                count:data.count,
                            });
                          }
                          else
                          {
                              this.setState({
                                  set_type:data.set_type,
                                  next_page:data.next_page,
                                  loadmore_status:data.load_more,
                                  loading_gif:false,
                              });
                          }
                      }
                      else
                      {
                        if(data.load_more===1)
                        {
                              this.setState({
                                  feedsList: this.state.feedsList.concat(data.products),
                                  set_type:data.set_type,
                                  next_page:data.next_page,
                                  loadmore_status:data.load_more,
                                  loading_gif:false,
                              });
                          } 
                          else
                          {
                              this.setState({
                                  set_type:data.set_type,
                                  next_page:data.next_page,
                                  loadmore_status:data.load_more,
                                  loading_gif:false,
                              });
                          }
                      }
                    }.bind(this),
                  error:function(err)
                  {
                      this.setState({
                        loading_gif:false,
                      })
                 }.bind(this)
        });
      }
  }
  refresh()
  {
    console.log("");
  }
  getDeviceId()
  {
    if(localStorage.user_id)
    {
        var user_id=localStorage.user_id;
    }
    else
    {
      user_id=0;
    }
    var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
    var data2=JSON.stringify(data1);
    $.ajax({
        method: 'POST',
        url: baseUrl+'getDeviceId',
        dataType: 'json',
        data:{req: data2},
        success: function(data)
        {
          
        },
        error: function(err)
        {
        }
    });
  }
// getTypes()
// {

//         var data1={from: 'desktop_web'};
//         var data2=JSON.stringify(data1);
//         $.ajax({
//         method: 'POST',
//         url: baseUrl+'getTypes',
//         dataType:'json',
//         data: {req:data2},
//         success: function(data){
//         this.setState({
//             types:data.types,
//         });
//         }.bind(this),
//         error: function(err){
//         console.log("Error"+err);
//         }
//         })
// }
    
  
getSelectedCatSort(event)
{

  var index = event.target.selectedIndex;
  var optionElement = event.target.childNodes[index];
  var id =  optionElement.getAttribute('id');
  // var name = event.target.value;
  this.setState({
        loading_gif:true,
        sortid:id,
  });
  localStorage.setItem('web_cat_sort',id);

  if(localStorage.user_id)
  {
    var  uid=localStorage.getItem('user_id')
  }
  else
  {
     uid=0;
  }
   
  var data1 ={from:'desktop_web',uid:uid,sort:id,pid:this.state.pid}
   var data2 =JSON.stringify(data1);
   $.ajax({
      url:baseUrl+'getNewsearch',
      method:'POST',
      dataType:'JSON',
      data:{req:data2},
      success:function(data)
      {
         if(data.status==='success')
         {
            if(data.products.length === 0)
            {
               this.setState({loading_gif:false});
            }
            this.setState({
              feedsList:data.products,
              offer: data,
              todata: data,
              loading:true,
              title: data.product_name,
              desc:'The best offers of AquaDeals',
              selected  : data.product_name,
              loadmore_status:data.load_more,
              set_type:data.set_type,
              next_page:data.next_page,
              loading_gif:false,
              count:data.count,
            });
         }
      }.bind(this),
      error:function(err)
      {

      }
   });
}      
test(type,tid,page)
{
    this.setState({
        loading_gif:true,
    });
    var uid =0;
    if(localStorage.user_id)
    {
      uid=localStorage.getItem('user_id')
    }
    else
    {
      uid=0;
    }
    var data1={from: 'desktop_web',uid:uid,dtype:this.state.data_type,type:type,tid:tid};
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'getProductbycat_brand',
          dataType:'json',
          data: {req:data2},
          success: function(data){
              this.setState({
                  feedsList:data.result,
                  offer: data,
                  loading:true,
                  bread: data.cat_name,
                  loadmore_status: data.load_more,
                  set_type:data.set_type,
                  next_page:data.next_page,
                  loading_gif:false,
              });
          }.bind(this),
          error: function(err)
          {
                this.setState({
                    loading_gif:false,
                });
          }
    });
}
        
// getPoductDeals(type,tid,dtype){

//     var data3={from: 'desktop_web',type:type, tid: tid, dtype:dtype};
//     var data4=JSON.stringify(data3);
//     var get_function = 'getProductbycat_brand'; 

//     $.ajax({
//         method: 'POST',
//         url: baseUrl+get_function,
//         dataType:'json',
//         data: {req:data4},
//         success: function(data1){
//         if(data1.products){
//                 this.setState({
//                 feedsList:data1.products,
//                 offer: data1,
//                 totdata: data1,
//                 loading:true,
//                 bread:data1.cat_name,
//             });
//         }else{
//             this.setState({
//                 feedsList:data1.result,
//                 offer: data1,
//                 totdata: data1,
//                 loading:true,
//             });
//         }

//         }.bind(this),
//         error: function(err){
//         console.log("Error"+err);
//         }
//     });
// }
componentDidMount()
{   
    localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_e_coupon_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('web_mycart');
    localStorage.removeItem('w_r_enq_seller_page');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('web_ofr_page');
    localStorage.removeItem('profile');
    localStorage.removeItem('myaquacash');
    localStorage.removeItem('web_share_earn');
    localStorage.removeItem('checkout');
    localStorage.removeItem('order_details');
    localStorage.removeItem('myorders');
    localStorage.removeItem('w_r_p_deals');
    localStorage.removeItem('seed');
    localStorage.removeItem('nauplii');
  
    localStorage.removeItem('shipping');
    localStorage.removeItem('notifications');
    localStorage.removeItem('web_quickcart');
    localStorage.removeItem('view_rating');
    localStorage.removeItem('w_modal_seed');
    localStorage.removeItem('w_r_seed_deals');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_modal_details');
    localStorage.removeItem('offers');
    localStorage.removeItem('give_rating');
    localStorage.removeItem('pprice');
    localStorage.removeItem('sprice');
    localStorage.removeItem('seed_id');
    localStorage.removeItem('h_type');
    localStorage.removeItem('web_pro_ofr_dtls');
    localStorage.removeItem('web_wishlist');
    localStorage.removeItem('web_brand_details');

    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_e_coupon_dt');
    localStorage.removeItem('m_r_e_s_dt');
    localStorage.removeItem('mob_mycart');
    localStorage.removeItem('m_r_enq_seller_page');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('m_r_e_p_dt');
    localStorage.removeItem('ofr_page');
    localStorage.removeItem('pro_ofr_dtls');

    localStorage.removeItem('share_earn');
    localStorage.removeItem('my_orders');
    localStorage.removeItem('m_r_p_deals');
    localStorage.removeItem('mob_quickcart');
    localStorage.removeItem('partner_deals');

    if(!localStorage.user_id && !localStorage.token)
    {
        if(this.props.params.BrandName && this.props.params.CatName && this.props.params.ProName && this.props.params.Pid && !this.props.params.DType)
        {
          localStorage.setItem('subdeals','/web/subdeals/'+this.props.params.BrandName+'/'+this.props.params.CatName+'/'+this.props.params.ProName+'/'+this.props.params.Pid)
        }
        else if(this.props.params.BrandName && this.props.params.CatName && this.props.params.DType && this.props.params.ProName && this.props.params.Pid)
        {
          localStorage.setItem('subdeals','/web/subdeals/'+this.props.params.BrandName+'/'+this.props.params.CatName+'/'+this.props.params.DType+'/'+this.props.params.ProName+'/'+this.props.params.Pid) 
        }  
    }
    

    var uid =0;
    if(localStorage.user_id)
    {
       uid=localStorage.getItem('user_id')
    }
    else
    {
       uid=0;
    }
    if(screen.width < 800 && this.props.params.BrandName && this.props.params.CatName && this.props.params.DType && this.props.params.ProName && this.props.params.Pid){
        window.location.href="/subdeals/"+this.props.params.BrandName+"/"+this.props.params.CatName+"/"+this.props.params.DType+"/"+this.props.params.ProName+"/"+this.props.params.Pid;
    }
    this.getDeviceId();
    localStorage.removeItem('w_r_p_deals');
    $(window).scrollTop(0);
        // localStorage.setItem('d_type',this.props.params.Dtype);
        
      var self = this;
      setTimeout(() => {self.setState({lod: true}); }, 15000);
        var data1={from: 'desktop_web',uid:uid,type: this.state.data_type};
        var data2=JSON.stringify(data1);
        $.ajax({
            method: 'POST',
            url: baseUrl+'getbrands_categoires',
            dataType:'json',
            data: {req:data2},
            success: function(data){
            this.setState({
                fulldata: data,
                feedbrands:data.brands,
                feedcat:data.categories,
                feed_sub_cat:data.categories[0].sub,
                dtype: this.props.params.Dtype,
                bread:'',
            });
            
        }.bind(this),
        error: function(err){
        // console.log("Error"+err);
        }
        })
        var data3={from: 'desktop_web',uid:uid,pid: this.state.pid,limit:20};
        var data4=JSON.stringify(data3);          
        


        $.ajax({
        method: 'POST',
        url: baseUrl+'getNewsearch',
        dataType:'json',
        data: {req:data4},
        success: function(data1){
            this.setState({
            feedsList:data1.products,
            offer: data1,
            totdata: data1,
            loading:true,
            loadmore_status:data1.load_more,
            set_type:data1.set_type,
            next_page:data1.next_page,
            h1_desc:'Shop best deals on '+data1.product_name,

            selected:data1.product_name,
            count:data1.count,
        });
        }.bind(this),
        error: function(err){
        // console.log("Error"+err);
        }
        });
      
}
  loadMoreDeals(num,type,tid,dtype)
  {
    this.setState({
        loading_gif:true,
    });
    var uid =0;
    if(localStorage.user_id)
    {
       uid=localStorage.getItem('user_id')
    }
    else
    {
       uid=0;
    }
    var data1={from: 'desktop_web',uid:uid,pid: tid,limit:20,page:num};
    var data2=JSON.stringify(data1);
    // if(type==="all"){
    //   // alert(type);
    //   data1={from :'desktop_web',page:num,type:dtype,limit:20};
    //   data2=JSON.stringify(data1);
    //   getfunc="getPoductDeals";
    // }
    // if(type==="Pcategory"){
    //   // alert(type);
    //   data1={from: 'desktop_web', page:num, dtype:dtype, type:type, tid:tid,limit:20};
    //   data2=JSON.stringify(data1);
    //   getfunc="getProductbycat_brand";
    // }
    // if(type==="brand"){
    //   // alert(type);
    //   data1={from:'desktop_web', page:num,dtype:dtype,type:type,tid:tid,limit:20};
    //   data2=JSON.stringify(data1);
    //   getfunc="getProductbycat_brand";
    // }
    
    var products="";
    $.ajax({
          method: 'POST',
          url: baseUrl+'getNewsearch',
          dataType:'json',
          data: {req:data2},
          success: function(data){
             
              this.setState({
                  offer: data,
                  totdata: data,
                  loading:true,
                  title:data.product_name,
                  desc:data.cat_desc,
                  selected  : data.product_name,
                  loadmore_status:data.load_more,
                  set_type: data.set_type,
                  next_page:data.next_page,

                  loading_gif:false,
                  count:data.count,
              });
            this.setState({ 
                feedsList: this.state.feedsList.concat(data.products),
            });
          }.bind(this),
          error:function(err)
          {
            this.setState({
                loading_gif:false,
            });
            // console.log(err);
          }
      });
  return products;
  }
  test1(id)
  {
        this.setState({
            loading_gif:true,
        });
        var data1={from: 'desktop_web',type:id};
        var data2=JSON.stringify(data1);
        $.ajax({
            method: 'POST',
            url: baseUrl+'getbrands_categoires',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
                this.setState({
                    fulldata: data,
                    feedbrands:data.brands,
                    feedcat:data.categories,
                    feed_sub_cat:data.categories[0].sub,
                    dtype: this.props.params.Dtype,
                    loading_gif:false,
                });
            }.bind(this),
            error: function(err)
            {
              // console.log("Error"+err);
              this.setState({
                  loading_gif:false,
              });
            }
        })

        var data3={from: 'desktop_web',type:id};
        var data4=JSON.stringify(data3);
        $.ajax({
            method: 'POST',
            url: baseUrl+'getPoductDeals',
            dataType:'json',
            data: {req:data4},
            success: function(data1)
            {
                this.setState({
                    feedsList:data1.result,
                    offer: data1,
                    loading:true,
                    loading_gif:false,
                });
            }.bind(this),
            error: function(err)
            {
              // console.log("Error"+err);
            } 
        });
  }
  setFilter(filter) {
    this.setState({selected  : filter})
  }
  isActive(value){
    return 'li '+((value===this.state.selected) ?'active':'');
  }
  render(){
        // document.title =this.state.totdata.product_name + " - Products | AquaDeals | "+"Browse best deals,Aquaculture products from "+this.state.totdata.product_name+" in AquaDeals. Contact customer care for any queries.";
        document.title =this.state.totdata.product_name ? this.state.totdata.product_name + " - Products | AquaDeals" : 'AquaDeals';
        document.getElementsByTagName("META")[2].content="Browse best deals,Aquaculture products from "+this.state.totdata.product_name+" in AquaDeals. Contact customer care for any queries."; 
        
        var sub_cat='';
        var brands = this.state.feedbrands.map(function(brand,index){
                        return(
                            <li key={brand.id} id={"brand_"+brand.id}>
                                <Link to={"/web/pdeals/"+brand.url_dtype_name+"/"+brand.url_name+"/"+brand.id+"/"+brand.type+"/"+brand.dtype}>
                                    <span>{brand.category_name}</span>
                                </Link>
                            </li>
                            );
                        });
    
       if(this.state.feed_sub_cat.length>0)
    {
        var cat= this.state.feedcat.map(function(cat,index){
                return(
                    <li key={cat.id} id={"cat_"+cat.id} className={this.isActive(cat.category_name)} onClick={this.setFilter.bind(this, cat.category_name)}>
                        <Link >
                             <span>
                            {cat.category_name}
                            </span>
                        </Link>
                    </li>);
                }.bind(this));
}
else
{
         cat= this.state.feedcat.map(function(cat,index){
                return(
                    <li key={cat.id} id={"cat_"+cat.id} className={this.isActive(cat.category_name)} onClick={this.setFilter.bind(this, cat.category_name)}>
                        <Link to={"/web/pdeals/"+cat.url_dtype_name+"/"+cat.url_name+"/"+cat.id+"/"+cat.type+"/"+cat.dtype}>
                             <span>
                            {cat.category_name}
                            </span>
                        </Link>
                    </li>);
                }.bind(this));
}
         sub_cat=this.state.feed_sub_cat.map(function(sub_cat,index){
            return(
                <li key={sub_cat.id} id={"sub_cat_"+sub_cat.id} className={this.isActive(sub_cat.category_name)} onClick={this.setFilter.bind(this, sub_cat.category_name)} >
                   <Link className="sub_cat_li" to={"/web/pdeals/"+sub_cat.url_dtype_name+"/"+sub_cat.url_name+"/"+sub_cat.id+"/"+sub_cat.type+"/"+sub_cat.dtype} >
                      <span>
                       {sub_cat.category_name}                
                      </span>     
                    </Link>
                </li>
            );
        }.bind(this));

        // var types= this.state.types.map(function(type,index){
        //             return(<li key={type.id} className="cat-0-list__item"><Link onClick={()=>{this.test1(type.id)}} to={"/"+type.url+"/"+type.id} className="cat-0-list__item--name">{type.type}</Link></li>);
        //           }.bind(this))
        
         var products='';
         if(this.state.feedsList.length >0){
                products = this.state.feedsList.map((product,index) => (<PDeal key={product.id} data={product} /> ));
        }
    //     var products=this.state.feedsList.map(function(product,index){ 
          
    //       return(
                
    //             <div>
    //             {product.pid ?
    //                 <Link key={product.index} className="col-md-3 col-sm-3 col-xs-3 itm_lst_grd" to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pid+"/"+product.deal_id}>
    //                         <div className="itm_img">
    //                                 <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
    //                         </div>
    //                         <h2>{product.title}</h2>
    //                         <h5>{product.brand_name}</h5>
    //                         <h6>{product.quantity}</h6>
    //                         {product.deal_price > 0 ? <p><span>&#8377;{product.mrp}</span><span>&#8377;{product.deal_price}</span></p> : <p><span>&#8377;{product.mrp}</span></p>}
    //                         <span className="share_btn"> <img src={baseAssets+'images/web_imgs/share.png'} alt="share" /> </span>
 
    //                 </Link> :    
    //         <Link key={product.index} className="col-md-3 col-sm-3 col-xs-3 itm_lst_grd" to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pro_id+"/"+product.id}>
    //                     <div className="itm_img">
    //                         <img className="itm_img" alt="Deals" src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
    //                     </div>
    //                     <h2>{product.title}</h2>
    //                     <h5>{product.brand_name}</h5>
    //                     <p><span>&#8377;{product.discount_amount}</span></p>
    //                     <h6><span>{product.quantity}</span></h6>
    //                     {product.deal_price > 0 ? <p><span>&#8377;{product.mrp}</span><span>&#8377;{product.deal_price}</span></p>: <p><span>&#8377;{product.mrp}</span></p>}
        
    //         </Link>
    //     } 
    //     </div>
    //   );
    // })
        return(
        <div className="web_Deals web_subdeals_page">  
        {this.state.loading ? <div className="lgt_gry">
                <WebHeaderInner />
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <div className="clr">&nbsp;</div>
                <h1 className="page_title">{this.state.h1_desc ? this.state.h1_desc : ''}</h1>
                <section className="container pro_lst_cntnt">
                   <div className="container">
                     <Breadcrumb className='webpdeals_breadcrmb'>
                       <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
                       <Breadcrumb.Item active>{this.state.selected}</Breadcrumb.Item>
                     </Breadcrumb> 
                   </div>
                  
                   {/* <!-- total products block start --> */}
                    <div className="tot_pro">
                       <div className="row" style={{marginRight:'0 !important'}}>
                         <div className="col-md-3 col-sm-3">
                           <div className="filtrs_blk">
                              <h3>Categories</h3>
                              <ul>
                                  {cat}
                                  {sub_cat}
                              </ul>
                               <h3>Brands</h3>
                               <ul className={brands.length > 10 ? 'flt_scrl' : 'no_scrl'}>
                                   {brands}
                               </ul>
                            </div> 
                        </div>
                         <div className="pro_sec col-md-9 col-sm-9">
                           {/*  <!-- products section header start --> */}
                          <div className="pro_sec_hdr">
                             <h3>{this.state.selected ? this.state.selected :'' }<span>({this.state.count} Items)</span></h3>
                            <div className="pro_slt_fltr">
                              <select onChange={this.getSelectedCatSort}>
                                <option>Select</option>
                                <option id='1'>Price:High-Low</option>
                                <option id='2'>Price:Low-High</option>
                              </select>
                            </div>
                          </div>
                         {/*  <!-- products section header end --> */}
                         {/* <!-- products blocks start --> */}
                          <div className="row itm_lst">
                            {this.state.loading_gif ? <i className="web_loading_gif"><img src={baseAssets+'images/loading_more.gif'} alt="Loading" /></i> : ''}   
                            <InfiniteScroll
                                        pullDownToRefresh
                                        pullDownToRefreshContent={
                                          <h3 style={{textAlign: 'center'}}>&#8595;</h3>
                                        }
                                        releaseToRefreshContent={
                                          <h3 style={{textAlign: 'center'}}>&#8593;</h3>
                                        }
                                        refreshFunction={this.refresh}
                                        next={this.fetchData}
                                        hasMore={true}
                                        scrollThreshold={0.9}
                                        loader={<h4></h4>}
                                        endMessage={
                                          <p style={{textAlign: 'center'}}>
                                            <b></b>
                                          </p>
                                        }>
                                        {products}
                                      </InfiniteScroll>
                            {products ? '' : <div>{this.state.lod ? <div className="seed_no_data">No Deals Available</div> : <div className="loading_sym" style={{width:'100%',textAlign:'center',marginTop:'10%'}}><img src={baseAssets+'images/web_imgs/ajax-loader.gif'} alt="Loading" role="presentation" /></div> }</div> }
                          </div>
                         {/* {this.state.loadmore_status === 1  ? <div className="web_loadmore_button" onClick={()=>{this.setState({ loadmore_number : this.state.loadmore_number+1 }); this.loadMoreDeals(this.state.next_page, this.state.set_type,this.props.params.Pid,this.props.params.DType)}}><i class="glyphicon glyphicon-circle-arrow-down"></i>Load More Deals</div> : ''} */}
                      </div> 
                    </div>
                   </div> 
                </section>
                <div className="clr">&nbsp;</div>
                  <WebFooter/>
             </div>:
             <div className="loading_sym" style={{width:100+'%',textAlign:'center',marginTop:20+'%'}}><img src={baseAssets+'images/web_imgs/ajax-loader1.gif'} alt="Loading Deals" role="presentation" /> </div>}</div>
        );
    }
}
export class PDeal extends Component{
    constructor(){
    super();
    this.state={
      open: false,
      shareUrl: '',
      msg:'',
      showModal: false,
      showModalLogin: false,

    };

    this.ShareFunc=this.ShareFunc.bind(this);
    this.modalOpen=this.modalOpen.bind(this);
    this.close=this.close.bind(this);
    this.closeModal=this.closeModal.bind(this);
    this.openLoginModal=this.openLoginModal.bind(this);
    }
    modalOpen(){
        this.setState({
            showModal: !this.state.showModal,
        });
    }
    closeModal(){
        this.setState({
            showModal: !this.state.showModal,
        });
    }
    close(){
        this.setState({
            showModal: false,
        });
    }
    openLoginModal(){
        this.setState({
            showModal: false,
            showModalLogin: true,
        })
    }
    closeLoginModal(){
        this.setState({
            showModal: false,
            showModalLogin: false,
        });
    }

    ShareFunc(evnt){
    var self = this;
    setTimeout(() => {self.setState({open: false}); }, 3000);
    var data1={from: 'desktop_web',type:1,did:evnt};
    var data2=JSON.stringify(data1);
    $.ajax({
          method: 'POST',
          url: baseUrl+'createTinyurl',
          dataType:'json',
          data: {req:data2},
          success: function(data){
            // console.log(data);
            this.setState({
              msg: data.msg,
              shareUrl: data.tinyurl,
            })
          }.bind(this),
        error: function(err){
          console.log("Error"+err);
        }
  });
    this.setState({
      open: !this.state.open 
    });
    setTimeout(() => {this.setState({open: false}); }, 5000);
  }
// <div className="col-md-3 col-sm-3 col-xs-3" style={{height: 300+'px'}}> 

    render(){
        var product=this.props.data;
        var shareUrl=this.state.shareUrl;
        var title="Hey! Click here "+ shareUrl +" to check "+product.title + " deal from AquaDeals.";
        var description=shareUrl;
        return(
          
<div className="col-md-3 col-sm-6"> 
    {product.pid ? 
  <div className="prdt_blk">
    {parseInt(product.ad_guarantee_flag,10) === 1 ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
          <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(product.deal_id)}}>
              <img src={baseAssets+'images/web_imgs/share.png'} alt="Share" />
          </Link>
          <Panel className="share_panel" collapsible expanded={this.state.open}>
                {/* <FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share"> */}
                <FacebookShareButton url={shareUrl} quote={title} className="test_share">
                        <FacebookIcon size={32} round />
                </FacebookShareButton>
                    
                <TwitterShareButton url={shareUrl} quote={title} className="test_share">
                        <TwitterIcon size={32} round />
                </TwitterShareButton>
              <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share">
                      <GooglePlusIcon  size={32} round />
              </GooglePlusShareButton>
          </Panel>
      {product.dealcount >= 2 ? <div>
        <Link to={"/web/subdeals/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.pid} >
            {product.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+product.promo_ribbion} alt="" /></i> : ''}
            <div>
                <img alt=" " src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
            </div>
              {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
              {product.brand_name ? <h4>{product.brand_name}</h4> : <h4>&nbsp;</h4>}
              {product.pricediff ? <h4>AquaCash Discount &#8377; {product.pricediff}</h4> : ''}
        </Link>
          <div className="row star_views_blk">
             <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
                <div className="prdt_str_rt">
                   <ReactStars
                      count={5}
                      className={'webRate_blk_item'}
                      size={17}
                      value={product.over_rate >=1 ? product.over_rate : 0}
                      edit={false}
                      color1={'#ccc'}
                      color2={'#ffc50a'} />
                 </div>
            </div>
            <div className="col-md-5 col-xs-5"  style={{paddingLeft:0}}>
               {product.deal_views > 0 ?  <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i>&nbsp;{product.deal_views}</span> : <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i> 0</span>}
            </div>
          </div>      
            {/*  <h6>{product.quantity}</h6> */}
            {/*  {product.deal_price > 0 ? <p><span>&#8377;{product.mrp}</span>&nbsp;<span>&#8377;{product.deal_price}</span></p> : <p><span></span><span>&#8377;{product.mrp}</span></p> } */}
    </div> :  
     <div>
        {parseInt(product.ad_guarantee_flag,10) === 1 ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
        <Link key={product.pid} to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pid+"/"+product.deal_id}>
           {product.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+product.promo_ribbion} alt="" /></i> : ''}
          <div>
            <img  alt=" " src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
          </div>
              {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
              {product.brand_name ? <h4>{product.brand_name}</h4> : <h4>&nbsp;</h4>}
              {product.pricediff ? <h4>AquaCash Discount &#8377; {product.pricediff}</h4> : ''}
        </Link>
        <div className="row star_views_blk">
          <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
             <div className="prdt_str_rt">
                <ReactStars
                  count={5}
                  className={'webRate_blk_item'}
                  size={17}
                  value={product.over_rate >=1 ? product.over_rate : 0}
                  edit={false}
                  color1={'#ccc'}
                  color2={'#ffc50a'} />
              </div>
          </div>
          <div className="col-md-5 col-xs-5"  style={{paddingLeft:0}}>
            {product.deal_views > 0 ? <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt="" /></i>&nbsp;{product.deal_views}</span> : <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt="" /></i> 0</span>}
          </div>
        </div>   
        <div className="clr"></div>  
           {/*    <h6>{product.quantity}</h6> */}
           {/*  {product.deal_price > 0 ? <p><span>&#8377;{product.mrp}</span>&nbsp;<span>&#8377;{product.deal_price}</span></p> : <p><span></span><span>&#8377;{product.mrp}</span></p>} */}
           {/*  {product.mrp ? <p><span></span><span>&#8377;{product.mrp}</span></p> : ''} */}
    </div>
    }
  </div>
    :    
    
    <div className="prdt_blk">
      {parseInt(product.ad_guarantee_flag,10) === 1 ? <span className="web_ad_guarantee"><img src={baseAssets+'images/product_imgs/ad_guarantee.png'} alt="presentation"/></span> : ''}
      <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(product.id)}}>
        <img src={baseAssets+'images/web_imgs/share.png'} alt="Share" />
      </Link>
      <Panel className="share_panel" collapsible expanded={this.state.open}>
          <FacebookShareButton url={shareUrl} quote={title} className="test_share">
              <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl} quote={title} className="test_share">
              <TwitterIcon size={32} round />
          </TwitterShareButton>
          <GooglePlusShareButton url={shareUrl} quote={title} className="test_share">
              <GooglePlusIcon  size={32} round />
          </GooglePlusShareButton>
      </Panel>
      <Link key={product.id} to={"/web/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.pro_id+"/"+product.id}>
            {product.promo_ribbion ? <i className="ribbon_img"><img src={baseAssets+'images/web_imgs/'+product.promo_ribbion} alt="" /></i> : ''}
            <div>
                <img  alt=" " src={baseAssets+'images/product_imgs/thumbnails/'+product.image}/>
            </div>
              {product.title ? <h3>{product.title} {product.quantity}</h3> : <h3>&nbsp;</h3>}
              {product.brand_name ? <h4>{product.brand_name}</h4> : <h4>&nbsp;</h4>}
              {product.pricediff ?  <h4><span>AquaCash Discount</span>&nbsp;<span>&#8377;{product.pricediff}</span></h4> : ''}
              {product.pricediff ==="" || product.pricediff===0 ? <h4>MRP &#8377; {product.mrp}</h4> : ''}
      </Link>
      <div className="row star_views_blk">
         <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
            <div className="prdt_str_rt">
              <ReactStars
                count={5}
                className={'webRate_blk_item'}
                size={17}
                value={product.over_rate >=1 ? product.over_rate : 0}
                edit={false}
                color1={'#ccc'}
                color2={'#ffc50a'} />
            </div>
         </div>
         <div className="col-md-5 col-xs-5" style={{paddingLeft:0}}>
             {product.deal_views > 0 ?  <span className="prdt_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/></i>&nbsp;{product.deal_views}</span> : <span className="prdt_views hide_views"><i><img src={baseAssets+'images/web_imgs/eye.png'} alt=""/> 0</i></span>}
         </div>
      </div>      
          {/*  <p><span></span><span>&#8377;{product.discount_amount}</span></p> */}
          {/*  {product.act_price > 0 ? <p style={{marginTop: 15+'px !important'}}><span>&#8377;{product.mrp}</span>&nbsp;<span>&#8377;{product.act_price}</span></p>: <p><span>&#8377;{product.mrp}</span></p>} */}
          {/* {product.mrp ? <p><span></span><span>&#8377;{product.mrp}</span></p> : ''} */}
        
    </div>
   } 
  </div>        
    );
    }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Feed/Web_subdeals.js
 **/